import { createContext, useContext, useRef, useState } from "react";
import { api } from "../../lib/api";
import { IFilters, IFiltersProps, IFiltersProvider, IStates } from "./types";
import { useAbortableRequest } from "../../hooks/abortableController";

export const FiltersContext = createContext<IFiltersProvider>(
  {} as IFiltersProvider
);

export const defaultFilters: IFilters = {
  search: "",
  insurance: "",
  location: "",
  spec: "",
  scheduType: "",
  selectedState: "",
  selectedCity: "",
  date: "",
  order: "",
  page: null,
  idPartner: null
};

export const FilterProvider = ({ children }: IFiltersProps) => {

  const { createController } = useAbortableRequest();
  const [filters, setFilters] = useState<IFilters>(defaultFilters);
  const [reseting, setReseting] = useState(false);
  const [states, setStates] = useState<string[]>([]);
  const [searchInputValue, setSearchInputValue] = useState<string>("");
  const [localModal, setLocalModal] = useState(false);
  const scrollToList = useRef(false);

  const resetFilters = () => {
    setReseting(true);
    setFilters(defaultFilters);
  };

  const handleGetStates = async () => {

    const abortController = createController('handleGetStates');

    try {
      const { data }: IStates = await api.get("/SpecialistDoctor/states", {
        signal: abortController.signal,
      });
      setStates(data);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <FiltersContext.Provider
      value={{
        filters,
        setFilters,
        resetFilters,
        reseting,
        setReseting,
        states,
        handleGetStates,
        searchInputValue,
        setSearchInputValue,
        localModal, 
        setLocalModal,
        scrollToList
      }}
    >
      {children}
    </FiltersContext.Provider>
  );
};

export const useFilters = () => useContext(FiltersContext);
